<template>
    <div class="login-wrap">
       
        <div class="ms-login">
            <div class="p">
                <img class="ms-title" src="../../assets/img/login_title.png" alt="" />
                <el-form :model="param"  ref="login" label-width="0px" class="ms-content" v-if="!showPass">
                    <el-form-item >
                        <div class="u_email" v-if="blurModel">
                            <el-input v-model="param.email" @focus="focus" @blur="blur">
                                <img slot="prefix" src="../../assets/img/em1.png" class="em"></img>
                            </el-input>
                        </div>
                        <div class="" v-else>
                            <el-input v-model="param.email" @focus="focus" @blur="blur">
                                <img slot="prefix" src="../../assets/img/em.png" class="em"></img>
                            </el-input>
                        </div>
                    </el-form-item>
                  
                    <el-form-item  class="u_password">
                        <div class="u_email" v-if="blurModel1">
                            <el-input type="password" show-password v-model="param.password" @focus="focus1" @blur="blur1">
                                <img slot="prefix" src="../../assets/img/password1.png" class="password"></img>

                            </el-input>
                        </div>
                        <div class="u_email1" v-else>
                            <el-input type="password" show-password v-model="param.password" @focus="focus1" @blur="blur1">
                                \
                                <img slot="prefix" src="../../assets/img/password.png" class="password"></img>

                            </el-input>
                        </div>
                    </el-form-item>
                    <p class="login-tips"  @click="getPassword">忘记密码？</p>
                    <div class="login-btn" @click="submitForm()" >
                        <div class="u_button">登录</div>
                    </div>
                </el-form>
                <el-form :model="param"  ref="login" label-width="0px" class="ms-content" v-else>
                    <el-form-item >
                        <div class="u_email" v-if="blurModel">
                            <el-input v-model="param.email" @focus="focus" @blur="blur">
                                <img slot="prefix" src="../../assets/img/em1.png" class="em"></img>
                            </el-input>
                        </div>
                        <div class="" v-else>
                            <el-input v-model="param.email" @focus="focus" @blur="blur">
                                <img slot="prefix" src="../../assets/img/em.png" class="em"></img>
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="u_email" v-if="blurMode2">
                            <el-input v-model="code" @focus="focus2" @blur="blur2">
                                <img slot="prefix" src="../../assets/img/code1.png" class="code" />
                                <div slot="suffix" class="getCode" @click.stop="senderVerficationCode" >获取验证码</div>
                            </el-input>
                        </div>
                        <div class="" v-else>
                            <el-input v-model="code" @focus="focus2" @blur="blur2">
                                <img slot="prefix" src="../../assets/img/code.png" class="code" />
                                <div slot="suffix" v-if="show" class="getCode" @click.stop="senderVerficationCode" >获取验证码</div>
                                <div slot="suffix" v-else class="getCode"  >{{count}}秒后重发</div>
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item  class="u_password">
                        <div class="u_email" v-if="blurModel1">
                            <el-input type="password" show-password v-model="param.password" @focus="focus1" @blur="blur1">
                                <img slot="prefix" src="../../assets/img/password1.png" class="password"></img>

                            </el-input>
                        </div>
                        <div class="u_email1" v-else>
                            <el-input type="password" show-password v-model="param.password" @focus="focus1" @blur="blur1">
                         
                                <img slot="prefix" src="../../assets/img/password.png" class="password" />

                            </el-input>
                        </div>
                    </el-form-item>
                    <p class="login-tips"  @click="getPassword1">返回</p>
                    <div class="login-btn" v-if="!showPass" @click="submitForm()">
                        <div  class="u_button">登录</div>
                    </div>
                    <div class="login-btn" v-else @click="resetForm()">
                        <div  class="u_button">登录</div>
                    </div>
                    

                </el-form>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            blurModel: false,
            blurModel1: false,
            blurMode2: false,
            show: true,
            count: '',
            timer: 0,
            showPass: false,
            param: {
                email: '',
                password: '' 
                // email: '380382123@qq.com',
                // password: 'x&F096010211' 
                // email: '344887562@qq.com',
                // password: '123456' 
            },
            code: ''
        };
    },
    created() {
       
    },
    methods: {
        // 失去焦点
        blur() {
            this.blurModel = false;
        },
        // 获取焦点
        focus() {
            this.blurModel = true;
        },
        blur1() {
            this.blurModel1 = false;
        },
        focus1() {
            this.blurModel1 = true;
        },
        blur2() {
            this.blurMode2 = false;
        },
        focus2() {
            this.blurMode2 = true;
        },
        // 忘记密码
        getPassword() {
            this.showPass = true;
            this.param.password = '';
            this.param.email = '';
            this.blurModel = false;
            this.blurModel1 = false;
            this.blurMode2 = false;
            this.code = '';
        },
        getPassword1() {
            this.showPass = false;
            this.param.password = '';
            this.param.email = '';
            this.blurModel = false;
            this.blurModel1 = false;
            this.blurMode2 = false;
            this.code = '';
        },
        senderVerficationCode() {
            if (this.param.email == '') {
                this.$message.error('请输入邮箱');
                return;
            }
            let TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                let timer = 0;
                timer = setInterval(() => {
                    if (this.count > 0 && this.count <= 120) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(timer);
                        timer = 0;
                    }
                }, 1000);

                this.getcode();
            }
        },
        getcode() {
            let that = this;
            let obj = {
                email: that.param.email
            };
            that.$post('/backapi/send_code', obj).then(function (res) {
                if (res.code == 200) {
                    that.$message.success('发送成功');
                } else {
                    that.$message.error(res.msg);
                }
            });
        },
        resetForm() {
            let that = this;
            if (that.code == '') {
                that.$message.error('请输入验证码');
                return;
            }
            if (that.param.password == '') {
                that.$message.error('请输入密码');
                return;
            }
            if (that.param.email == '') {
                that.$message.error('请输入邮箱');
                return;
            }
            let obj = {
                email: that.param.email,
                code: that.code,
                password: that.param.password
            };
            that.$post('/backapi/reset_password', obj).then(function (res) {
                if (res.code == 200) {
                    // that.param = {};
                    // that.code = '';
                    // that.showPass = false;
                    // that.$message.success('修改成功');
                    that.submitForm()
                } else {
                    that.$message.error(res.mag);
                }
            });
        },
        submitForm() {
            let that = this;
            if (that.param.password == '') {
                that.$message.error('请输入密码');
                return;
            }
            if (that.param.email == '') {
                that.$message.error('请输入邮箱');
                return;
            }
            that.$refs.login.validate((valid) => {
                if (valid) {
                    that.$post('/backapi/login', that.param).then(function (res) {
                        // console.log(res.data);

                        that.$message({
                            showClose: true,
                            message: '登录成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                localStorage.setItem('user_type', res.data.user_type);
                                localStorage.setItem('token', res.data.token);
                                localStorage.setItem('user', JSON.stringify(res.data));
                                that.$get('/backapi/area', {}).then(function (res1) {
                                    localStorage.setItem('area', JSON.stringify(res1.data));
                                    if (localStorage.getItem('user_type') == 'user') {
                                        that.$router.push('/detail');
                                    } else {
                                        that.$router.push('/');
                                    }
                                });
                            }
                        });
                    });
                } else {
                    that.$message.error('请输入账号和密码');
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
.getCode {
    width: 104px;
    height: 39px;
    /* left: 740px; */
    /* top: 309px; */
    background: #33498c;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    /* identical to box height, or 16px */
    letter-spacing: 0.005em;
    color: #ffffff;
    position: absolute;
    top: 7px;
    right: -15px;
    cursor: pointer;
}
/deep/.el-input__inner {
    width: 387px;
    height: 53px;
    background: #ffffff;
    border: 1px solid #91d9f2;
    box-shadow: 0px 0px 16px rgba(145, 217, 242, 0.2);
    border-radius: 4px;
    padding: 0 50px;
    font-weight: 400;
    font-size: 16px;
    color: #697077
}

/deep/.u_email .el-input .el-input__inner {
    border: 1px solid #33498c;
}

.u_email {
    /* width: 387px;
    height: 53px;
    background: #ffffff;
    box-shadow: 0px 0px 16px rgba(145, 217, 242, 0.2);
    border-radius: 4px;
    padding: 0 50px;
    border: 1px solid #33498C; */
}

.em {
    width: 31px;
    height: 31px;
}
.code {
    width: 22.71px;
    height: 25.68px;
}
.password {
    width: 28px;
    height: 28px;
}

/deep/.el-input__prefix {
    left: 11px;
    display: flex;
    align-items: center;
}

/deep/.el-input__suffix-inner {
    right: 20px;
    height: 100%;
    position: absolute;
}

/deep/.el-input .el-input__clear {
    font-size: 20px;
}

.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background: url(../../assets/img/bg.png) no-repeat;
    background-size: cover;
}

.ms-title {
    width: 204.31px;
    height: 93.66px;
    margin-bottom: 39px;
}

.p {
    padding: 24px 0 32px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ms-login {
    position: absolute;

    left: 50%;
    top: 50%;
    width: 648px;
    /* height: 469px; */
    border: 1px solid #dde1e6;
    border-radius: 16px;
    background: #ffffff;
    overflow: hidden;
    transform: translate(-50%, -50%);
}

.ms-content {
}

.login-btn {
    text-align: center;
}

.login-btn {
    width: 387px;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #16307c;
    border: 1px solid #16307c;
    box-shadow: 2px 3px 4px rgba(0, 24, 96, 0.2);
    border-radius: 8px;
}

/deep/.el-form-item {
    margin-bottom: 24px;
}

/deep/.u_password.el-form-item {
    margin-bottom: 15px;
}

.login-tips {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;

    letter-spacing: 0.005em;

    color: #91d9f2;
    margin-bottom: 66px;
}

.u_button {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 100%;
    /* identical to box height, or 28px */

    letter-spacing: 0.16em;

    color: #ffffff;
}
</style>
